import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center field-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M1000"),
  /*#__PURE__*/_createTextVNode(" From which of the following "),
  /*#__PURE__*/_createElementVNode("b", { class: "ms-1 me-1" }, "Inpatient Facilities "),
  /*#__PURE__*/_createTextVNode(" was the patient discharged within the past 14 days?(Mark all that apply) "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "form-check custom-checkbox pb-1 ms-2"
}
const _hoisted_5 = ["id", "value", "checked", "onChange"]
const _hoisted_6 = ["for"]
const _hoisted_7 = {
  key: 1,
  class: "d-flex bg-white flex-column ms-4 w-40 pb-4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "service-required-text-color" }, "Other Admission Source ", -1 /* HOISTED */)
const _hoisted_9 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0 mt-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge me-1" }, "M0110"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("b", null, "Episode Timing"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "field-title" }, " Is the Medicare home health episode, for which this assessment will define a case-mix group, an \"early\" episode or a \"later\" episode in the patient's current sequence of adjacent Medicare home health payment episodes? ", -1 /* HOISTED */)
const _hoisted_12 = ["id", "value", "checked", "onClick"]
const _hoisted_13 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Admission Source and Timing (PDGM)",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", {
            class: _normalizeClass(`${
                            _ctx.v$.referral.Demographics.AdmissionSources.$error ||
                            _ctx.errors.Demographics.includes('AdmissionSources')
                                ? 'border border-warning p-2 rounded'
                                : ''
                        }`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.admissionOptionsToDisplay, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${option.value}-${option.label}`
              }, [
                (_ctx.showCheckbox(option))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("input", {
                        type: "checkbox",
                        class: "form-check-input",
                        id: `${option.value}-${option.label}`,
                        value: option.value,
                        checked: _ctx.isAdmissionSourceChecked(option),
                        onChange: ($event: any) => (_ctx.handleAdmissionSource(option.value)),
                        onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.AdmissionSources.$touch && _ctx.v$.referral.Demographics.AdmissionSources.$touch(...args)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `${option.value}-${option.label}`
                      }, [
                        _createElementVNode("small", null, _toDisplayString(option.label), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_6)
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.showOtherAdmissionSource && option.value === 64)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control w-90",
                        placeholder: "Enter Admission Source",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.Demographics.AdmissionSourceOther) = $event)),
                        maxlength: "300"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.referral.Demographics.AdmissionSourceOther]
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", {
            class: _normalizeClass(`${
                            _ctx.v$.referral.Demographics.EpisodeTiming.$error ||
                            _ctx.errors.Demographics.includes('EpisodeTiming')
                                ? 'border border-warning p-2 rounded'
                                : ''
                        }`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.episodeTiming, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "form-check ms-2 pb-1",
                key: `${option.value}-${option.label}`
              }, [
                _createElementVNode("input", {
                  type: "radio",
                  class: "form-check-input",
                  id: `${option.value}-${option.label}`,
                  value: option.value,
                  checked: option.value === _ctx.referral.Demographics.EpisodeTiming,
                  onClick: ($event: any) => (_ctx.handleEpisodeTimingChange(option.value)),
                  onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.v$.referral.Demographics.EpisodeTiming.$touch && _ctx.v$.referral.Demographics.EpisodeTiming.$touch(...args)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12),
                _createElementVNode("label", {
                  class: "form-check-label mb-2",
                  for: `${option.value}-${option.label}`
                }, [
                  _createElementVNode("small", null, _toDisplayString(option.label), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_13)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 2 /* CLASS */)
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}